import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import "./style/index.less"
import permission from './directives/permission'
import Upload from './components/Upload/index.vue'

Vue.use(ElementUI)
// 注册全局权限指令 v-permission
Vue.directive('permission', permission)
// 注册全局上传组件 <hx-upload>
Vue.component('Upload', Upload)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
